import wheelDirection from './component/wheelDirection';
import isPreventTime from './component/isPreventTime';

import Intro from './page/intro';
import PartOne from './page/partOne';
import PartTwo from './page/partTwo';
import Sand from './page/sand';
import Update from './page/Update';
import Event from './page/Event';

const intro = new Intro();
const partOne = new PartOne();
const partTwo = new PartTwo();
const sand = new Sand();
const update = new Update();
const event = new Event();

const page = {intro, partOne, partTwo, sand, update, event};
let context = $('.section-page');
let nowCount = 0;
let maxCount = 9;
let currentPage = ['intro', 'intro1'];
let DOM_MovieLayer = $('.layer-movie');

let setPage = (direction) =>{
    if(nowCount + direction < 0 || nowCount + direction > maxCount) return;
    nowCount = nowCount + direction;
    
    render(nowCount);
};

let render = (renderId) =>{
    let go, id;
    [go, id] = pageMap(renderId);
    
    let query = go + id;
    
    if(currentPage){
        page[currentPage[0]].reset(currentPage[1]);
    }
    
    setNaviActive(query);
    
    page[go].start(query);
    currentPage = [go, query];
};

let setNaviActive = (query) =>{
    $('.nav-list a').removeClass('active');
    
    switch(query){
        case 'partOne1':
        case 'partOne2':
            $('[href="#page-part1"]').addClass('active');
            break;
        case 'partTwo1':
        case 'partTwo2':
            $('[href="#page-part2"]').addClass('active');
            break;
        case 'sand1':
        case 'sand2':
            $('[href="#page-sand"]').addClass('active');
            break;
        case 'update1':
        case 'update2':
            $('[href="#page-update"]').addClass('active');
            break;
        case 'event1':
            $('[href="#page-event"]').addClass('active');
            break;
    }
};

let pageMap = (value) =>{
    let map = {
        0: ['intro', 1],
        1: ['partOne', 1],
        2: ['partOne', 2],
        3: ['partTwo', 1],
        4: ['partTwo', 2],
        5: ['sand', 1],
        6: ['sand', 2],
        7: ['update', 1],
        8: ['update', 2],
        9: ['event', 1]
    };
    
    return map[value];
};

let naviMap = (value) =>{
    let map = {
        '#page-intro': 0,
        '#page-part1': 1,
        '#page-part2': 3,
        '#page-sand': 5,
        '#page-update': 7,
        '#page-event': 9
    };
    return map[value];
};

$(document).on('click', '.btn-link-index', function(e){
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

$(document).on('click', '.nav-list a', function(e){
    e.preventDefault();
    nowCount = naviMap(this.hash);
    render(nowCount);
});

nc.ui.Player.movieLayer = new nc.ui.Player({
    selector: '#movie-box',
    videoId: 'GyGKpAo8Wz0',
    mute: false,
    controls: true
});

$(document).on('click', '.btn-link-play', function(e){
    e.preventDefault();
    DOM_MovieLayer.fadeIn();
    nc.ui.Player.movieLayer.play();
    $(window).trigger('resize');
});

$(document).on('click', '.layer-movie .btn-close', function(e){
    e.preventDefault();
    nc.ui.Player.movieLayer.stop();
    DOM_MovieLayer.fadeOut();
});

context.on('mousewheel DOMMouseScroll', (e) =>{
    e.stopPropagation();
    if(isPreventTime(window.lastWheelTime)) return;
    window.lastWheelTime = new Date().getTime();
    
    setPage(wheelDirection(e));
});

new nc.ui.Preloader({
    'resourcePath': '/promo/bns/history/2017/170913_taecheon',
    'delay': 500,
    'preLoadList': [
        '/img/update/bg-update.jpg',
        '/img/update/obj4-ch1.png',
        '/img/update/obj4-ch2.png',
        '/img/update/obj4-dis1.png',
        '/img/update/obj4-dis2.png',
        '/img/update/obj4-img1.png',
        '/img/update/obj4-img2.png',
        '/img/update/obj4-tit.png',
        '/img/update/obj4-txt1.png',
        '/img/update/obj4-txt2.png',
        '/img/sand/obj3-ch1-off.png',
        '/img/sand/obj3-ch1.png',
        '/img/sand/obj3-ch2-off.png',
        '/img/sand/obj3-ch2.png',
        '/img/sand/obj3-dis1.png',
        '/img/sand/obj3-dis2.png',
        '/img/sand/obj3-tit.png',
        '/img/sand/obj3-txt1.png',
        '/img/sand/obj3-txt2.png',
        '/img/part2/obj2-ch1-off.png',
        '/img/part2/obj2-ch1.png',
        '/img/part2/obj2-ch2-off.png',
        '/img/part2/obj2-ch2.png',
        '/img/part2/obj2-dis1.png',
        '/img/part2/obj2-tit.png',
        '/img/part2/obj2-txt1.png',
        '/img/part2/obj2-txt2.png',
        '/img/part1/obj1-ch1-off.png',
        '/img/part1/obj1-ch1.png',
        '/img/part1/obj1-ch2-off.png',
        '/img/part1/obj1-ch2.png',
        '/img/part1/obj1-dis1.png',
        '/img/part1/obj1-dis2.png',
        '/img/part1/obj1-tit.png',
        '/img/part1/obj1-txt1.png',
        '/img/part1/obj1-txt2.png',
        '/img/intro/bg-arrow.png',
        '/img/intro/bg-back.jpg',
        '/img/intro/btn-play.png',
        '/img/intro/circle.png',
        '/img/intro/obj0-ch2.png',
        '/img/intro/obj0-tit.png',
        '/img/intro/obj0-txt1.png',
        '/img/intro/obj0-txt4.png',
        '/img/intro/txt-scroll.png',
        '/img/event/bg-event.jpg',
        '/img/event/obj5-card1.png',
        '/img/event/obj5-card2.png',
        '/img/event/obj5-clip3.png',
        '/img/event/obj5-clip4.png',
        '/img/event/obj5-state.png',
        '/img/event/obj5-tit.png',
        '/img/common/bet.png',
        '/img/common/bg-bottom.png',
        '/img/common/bg-cover.png',
        '/img/common/bg-fog.png',
        '/img/common/bg-footer.png',
        '/img/common/bg-logo.png',
        '/img/common/bg-menu.png',
        '/img/common/bg-nav.png',
        '/img/common/bg-util.png',
        '/img/common/bg-video.png',
        '/img/common/btn_close.png',
        '/img/common/sns.jpg'
    ],
    'devName': 'bns'
});

$(document).on('preLoaded', function(){
    $('.container').show();
    page['intro'].start('intro1');
    $(window).resize();
    $('.header').addClass('animate');
});


// WEBPACK FOOTER //
// ./history/2017/170913_taecheon/_src/js/App.js